<div class="pos-relative">
    <div class="_colour-popup overflow-hidden"
         [ngClass]="{'_colour-popup--visible' : !!colourPopupEvent}"
         [ngStyle]="colourPopupStyle ? colourPopupStyle : {}">
        @if(colourPopupEvent){

        @switch (colourPopupEvent.type) {
        <!-- image -->
        @case ('image') {
        <img class="w-12"
             [ratio]="1"
             [dfImage]="colourPopupEvent.swatch" />
        }
        <!-- color -->
        @case ('background') {
        <span class="ratio-1-1 block"
              [ngStyle]="{'background-color' : colourPopupEvent.swatch}"></span>
        }
        }
        @if(colourPopupEvent.title){
        <div class="p-a-2 b-t b-col-5 bg-col-w">
            <span class="h4 block">{{colourPopupEvent.title}}</span>
            @if(colourPopupEvent.subtitle){
            <div class="b-a b-col-1 p1 p-t-2 p-b-2 p-l-3 p-r-3 inline-block m-t-2"
                 style="border-radius: 12px;">
                {{colourPopupEvent.subtitle}}
            </div>
            }
        </div>
        }
        }
    </div>
    @if (content) {
    <div class="wrap-x wrap-l flex-x flex-l _main p-b-8-s p-b-8-m">

        @if(isSM){
        <product-view-details-name class="wrap block"
                                   [content]="content"
                                   [product]="product"></product-view-details-name>
        }

        <div class="pos-relative w-12 flex-x flex-l m-t-4-s m-t-4-m">
            <!-- media -->

            <div class="c-6 c-12-m c-12-s m-b-0 pos-relative">
                <div class="pos-relative">
                    <product-view-media class="block"
                                        [source]="product" />
                </div>
                @if(!isSM){
                <product-view-details-left class="w-12 m-t-5"
                                           [product]="product"
                                           [attributes]="content.attributes">
                </product-view-details-left>
                <product-view-related-carousel class="block m-t"
                                               [source]="product"
                                               [title]="'You may need'"
                                               [options]="{engines: 'related'}" />
                }
            </div>
            <div class="c-6 c-12-m c-12-s m-r-0 m-b-0 pos-relative">

                <product-view-details class="w-12 p-b p-b-8-s p-b-8-m"
                                      [stickyPanel]="client.sizeId > 1"
                                      [content]="content"
                                      [product]="product">
                </product-view-details>


            </div>
        </div>
        @if(isSM){
        <product-view-details-left class="w-12 wrap"
                                   [product]="product"
                                   [attributes]="content.attributes">
        </product-view-details-left>
        <product-view-related-carousel class="_mobile-carousel block m-t"
                                       [source]="product"
                                       [title]="'You may need'"
                                       [options]="{engines: 'related'}" />
        }
    </div>
    }

    <!-- prop65 warning -->
    @if (product.getAttr('prop_65') && product.getAttr('prop_65_notice')) {
    <div class="wrap m-t-6-x m-t-6-l m-b-6">
        <product-view-prop65-warning [product]="product"></product-view-prop65-warning>
    </div>
    }

    @if (content) {
    <div class="flex flex-column w-12 wrap m-t-5">
        <h2 class="m-b h2 _reviews-title">{{'Reviews' | translate}}</h2>
        <icms-outlet [components]="content.bottomComponents"
                     class="w-12"
                     [allowOnly]="['product-trustpilot-widget']">
        </icms-outlet>
    </div>
    <div class="flex flex-column w-12 wrap m-t-5">
        <icms-outlet-block class="w-12"
                           [variant]="product.pdpComponentsOutletVariant"
                           [allowOnly]="['ugc', 'text', 'information-faq', 'case-studies', 'blog-more-stories']"></icms-outlet-block>
    </div>
    }
</div>